



















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import IOption from "@/models/IOption";
import AppConfig from "@/config/AppConfig";
import {Action, Getter} from "vuex-class";
import ApiTable from "@/components/ApiTable/ApiTable.vue";

@Component({
  components: {ApiTable}
})
export default class TypesReport extends Vue {
  public name: string = "TypesReport";

  @Prop({required: true})
  public report!: any;

}
